import React, { Component } from "react";
import CommonBreadCrumb from "../breadCrumbs";
import InvestorRouter from "./InvestorRoutes";

export const INVESTOR_URL = `/investors`;

const breadcrumbNameMap = {
  "/investors": { title: "Investors", to: INVESTOR_URL },
  "/investors/details": {
    title: "Investor Details",
    to: `${INVESTOR_URL}/details`,
  },
};

export default class InvestorComponent extends Component {
  render() {
    const { location } = this.props;
    const pathnames = location.pathname
      .split("/")
      .filter((name) => name)
      .slice(0, 2);
    return (
      <div>
        <CommonBreadCrumb
          hideFirst={true}
          pathnames={pathnames}
          breadcrumbNameMap={breadcrumbNameMap}
        />
        <InvestorRouter />
      </div>
    );
  }
}
